<template>
	<div class="tw-w-4 tw-my-auto">
		<FontAwesomeIcon :class="props.customStyle" :icon="icon" />
	</div>
</template>
<script setup lang="ts">
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {computed} from "vue";
import {findIconByDeviceType} from "@/utils/devices/deviceTypes/findIconByDeviceType";

const props = defineProps({
	deviceType: {
		type: String,
		required: true,
	},
  customStyle: {
		type: String,
		required: false,
	},
});

const icon = computed(() => findIconByDeviceType(props.deviceType));
</script>
